// extracted by mini-css-extract-plugin
module.exports = {"container":"features_container__I1t2L","card":"features_card__l477s","svg":"features_svg__NtR_f","text":"features_text__Qamkw"};